<template>
  <div class="layout-wrapper outer-layout">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'ShareLayout',
}
</script>

<style lang="scss">
 
</style>